(() => {
  const tabs = document.querySelectorAll(".custom-tab .tab-item");
  let active = 0;
  const sectionAll = document.querySelectorAll(".shopify-section.section");
  const section = [];
  const customTab = document.querySelector(".custom-tab");
  const customTabContent = customTab?.querySelector(".custom-tab-content");
  const customTabSection = customTab?.parentNode;
  const keyword = /featured_collection/;
  const keyword2 = /custom_collection/;
  const titleGap = 20;
  const scrollDuration = 500;
  let verticalScrollFrame = null;
  let scrollSpyFrame = null;
  let correctionTimers = [];
  let previousScrollBehavior = null;

  if (!customTab || !customTabContent || !customTabSection) return;

  sectionAll.forEach((element) => {
    if (keyword.test(element.id) || keyword2.test(element.id)) {
      section.push(element);
    }
  });

  function getScrollBehavior() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "smooth";
  }

  function restoreDocumentScrollBehavior() {
    if (previousScrollBehavior === null) return;

    document.documentElement.style.scrollBehavior = previousScrollBehavior;
    previousScrollBehavior = null;
  }

  function stopVerticalScroll() {
    if (verticalScrollFrame !== null) {
      window.cancelAnimationFrame(verticalScrollFrame);
      verticalScrollFrame = null;
    }

    correctionTimers.forEach((timer) => window.clearTimeout(timer));
    correctionTimers = [];

    restoreDocumentScrollBehavior();
    scheduleActiveTabUpdate();
  }

  function createTabSlug(value) {
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[łŁ]/g, (character) =>
        character === "Ł" ? "L" : "l"
      )
      .toLowerCase()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function scrollTabIntoView(item, behavior = getScrollBehavior()) {
    if (customTab.scrollWidth <= customTab.clientWidth) return;

    const customTabRect = customTab.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const left =
      customTab.scrollLeft +
      itemRect.left -
      customTabRect.left -
      (customTab.clientWidth - itemRect.width) / 2;

    if (typeof customTab.scrollTo === "function") {
      try {
        customTab.scrollTo({
          left,
          behavior,
        });
        return;
      } catch {
        customTab.scrollLeft = left;
        return;
      }
    }

    customTab.scrollLeft = left;
  }

  function setParentNodeTop() {
    const navHeight = document.querySelector("header.header");
    const topNotifications = document.querySelector(
      ".shopify-section.shopify-section-group-header-group.announcement-bar-section"
    );

    customTabSection.style.top = `${
      (navHeight ? navHeight.offsetHeight : 0) +
      (topNotifications ? topNotifications.offsetHeight : 0)
    }px`;
    customTabSection.style.position = "sticky";
    customTabSection.style.zIndex = "1";

    const nativeScrollOffset =
      parseFloat(customTabSection.style.top) + customTab.offsetHeight;

    section.forEach((targetSection) => {
      targetSection.style.scrollMarginTop = `${nativeScrollOffset}px`;
    });
  }

  function scrollToSection(
    targetSection,
    behavior = getScrollBehavior()
  ) {
    setParentNodeTop();

    const targetTitle =
      targetSection.querySelector(".collection__title") || targetSection;

    function getTargetScrollTop() {
      const stickyTop = parseFloat(
        window.getComputedStyle(customTabSection).top
      );
      const stickyOffset =
        (Number.isFinite(stickyTop) ? stickyTop : 0) +
        customTab.offsetHeight;

      return Math.max(
        0,
        window.scrollY +
          targetTitle.getBoundingClientRect().top -
          stickyOffset -
          titleGap
      );
    }

    function correctTitlePosition() {
      const targetScrollTop = getTargetScrollTop();

      if (Math.abs(window.scrollY - targetScrollTop) <= 1) return;

      const currentScrollBehavior =
        document.documentElement.style.scrollBehavior;

      document.documentElement.style.scrollBehavior = "auto";
      window.scrollTo(0, targetScrollTop);
      document.documentElement.style.scrollBehavior = currentScrollBehavior;
    }

    function scheduleTitleCorrections() {
      correctTitlePosition();

      [250, 750].forEach((delay) => {
        const timer = window.setTimeout(() => {
          correctTitlePosition();
          correctionTimers = correctionTimers.filter(
            (timerId) => timerId !== timer
          );
        }, delay);

        correctionTimers.push(timer);
      });
    }

    stopVerticalScroll();
    previousScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "auto";

    if (behavior === "auto") {
      window.scrollTo(0, getTargetScrollTop());
      restoreDocumentScrollBehavior();
      scheduleTitleCorrections();
      return;
    }

    const startScrollTop = window.scrollY;
    const startTime = window.performance.now();

    function animateScroll(currentTime) {
      const progress = Math.min(
        (currentTime - startTime) / scrollDuration,
        1
      );
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const targetScrollTop = getTargetScrollTop();

      window.scrollTo(
        0,
        startScrollTop +
          (targetScrollTop - startScrollTop) * easedProgress
      );

      if (progress < 1) {
        verticalScrollFrame = window.requestAnimationFrame(animateScroll);
        return;
      }

      window.scrollTo(0, getTargetScrollTop());
      verticalScrollFrame = null;
      restoreDocumentScrollBehavior();
      scheduleTitleCorrections();
    }

    verticalScrollFrame = window.requestAnimationFrame(animateScroll);
  }

  function setActiveTab(index) {
    active = index;

    tabs.forEach((item, itemIndex) => {
      const isActive = itemIndex === active;

      item.classList.toggle("tab-item-active", isActive);
      item.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateActiveTabFromScroll() {
    scrollSpyFrame = null;

    if (verticalScrollFrame !== null || correctionTimers.length > 0) return;

    const viewportBottom = window.innerHeight;
    const viewportTop = Math.min(
      viewportBottom,
      Math.max(0, customTab.getBoundingClientRect().bottom)
    );
    let visibleIndex = -1;
    let visibleHeight = 0;
    let lastSectionIndex = -1;

    section.forEach((targetSection, index) => {
      if (!tabs[index]) return;

      lastSectionIndex = index;
      const rect = targetSection.getBoundingClientRect();
      const height = Math.max(
        0,
        Math.min(rect.bottom, viewportBottom) - Math.max(rect.top, viewportTop)
      );

      if (height > visibleHeight) {
        visibleHeight = height;
        visibleIndex = index;
      }
    });

    if (
      window.scrollY > 0 &&
      window.scrollY + viewportBottom >= document.documentElement.scrollHeight - 1
    ) {
      visibleIndex = lastSectionIndex;
    }

    if (visibleIndex < 0 || visibleIndex === active) return;

    setActiveTab(visibleIndex);
    scrollTabIntoView(tabs[visibleIndex]);
  }

  function scheduleActiveTabUpdate() {
    if (scrollSpyFrame !== null) return;

    scrollSpyFrame = window.requestAnimationFrame(updateActiveTabFromScroll);
  }

  function updateTabQuery(item) {
    const tabSlug = item.dataset.tab;

    if (!tabSlug || typeof window.history.replaceState !== "function") {
      return;
    }

    const url = new URL(window.location.href);

    url.searchParams.set("tab", tabSlug);
    window.history.replaceState(window.history.state, "", url.toString());
  }

  function getRequestedTabIndex() {
    const requestedTab = new URLSearchParams(window.location.search).get(
      "tab"
    );

    if (!requestedTab) return -1;

    const requestedSlug = createTabSlug(requestedTab);

    return Array.from(tabs).findIndex(
      (item) => item.dataset.tab === requestedSlug
    );
  }

  function activateTab(
    index,
    { behavior = getScrollBehavior(), updateQuery = false } = {}
  ) {
    const item = tabs[index];
    const targetSection = section[index];

    if (!item) return;

    setActiveTab(index);
    scrollTabIntoView(item, behavior);

    if (targetSection) {
      scrollToSection(targetSection, behavior);
    }

    if (updateQuery) {
      updateTabQuery(item);
    }
  }

  tabs.forEach((item, index) => {
    const targetSection = section[index];
    const tabSlug = createTabSlug(item.textContent.trim());

    item.removeAttribute("href");
    item.setAttribute("role", "button");
    item.setAttribute("aria-pressed", "false");
    item.dataset.tab = tabSlug || `tab-${index + 1}`;
    item.tabIndex = 0;

    if (targetSection) {
      item.setAttribute("aria-controls", targetSection.id);
    }

    item.addEventListener("click", function (event) {
      event.preventDefault();
      activateTab(index, { updateQuery: true });
    });

    item.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;

      event.preventDefault();
      item.click();
    });
  });

  setParentNodeTop();
  const requestedTabIndex = getRequestedTabIndex();

  setActiveTab(requestedTabIndex >= 0 ? requestedTabIndex : 0);

  if (requestedTabIndex >= 0) {
    window.requestAnimationFrame(() => {
      activateTab(requestedTabIndex, { behavior: "auto" });
    });
  }

  ["wheel", "touchstart", "pointerdown"].forEach((eventName) => {
    window.addEventListener(eventName, stopVerticalScroll, { passive: true });
  });
  window.addEventListener("keydown", stopVerticalScroll, true);
  window.addEventListener("scroll", scheduleActiveTabUpdate, { passive: true });
  window.addEventListener("load", scheduleActiveTabUpdate);
  window.addEventListener("resize", function () {
    stopVerticalScroll();
    setParentNodeTop();
  });
  window.addEventListener("popstate", function () {
    const index = getRequestedTabIndex();

    if (index >= 0) {
      activateTab(index, { behavior: "auto" });
    }
  });
  scheduleActiveTabUpdate();
})();
